// extracted by css-extract-rspack-plugin
export default {"cls1":"server_side_bulk_downloader-cls1_HhZ","cls2":"server_side_bulk_downloader-cls2_dwD server_side_bulk_downloader-cls1_HhZ"};